import { isEmpty } from './index'

export const required = value => (value && value.length ? true : 'Este campo é obrigatório')
export const requiredSemMensagem = value => value && value.length

export const select = value => (value ? true : 'Este campo é obrigatório')

export const emailValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  // eslint-disable-next-line
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (Array.isArray(value)) {
    return value.every(val => re.test(String(val)))
  }

  return re.test(String(value)) || 'O campo e-mail deve ter um email válido'
}

export const passwordValidator = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^a-zA-Z\d\s])([A-Za-z\d]|[^a-zA-Z\d\s]){8,40}$/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)

  return (
    // eslint-disable-next-line operator-linebreak
    validPassword ||
    'O campo deve conter pelo menos uma letra maiúscula, minúscula, caractere especial e dígito, tendo no mínimo 8 caracteres e no máximo 40'
  )
}

export const confirmedValidator = (value, target) => value === target || 'As senhas não correspondem'

export const between = (value, min, max) => () => {
  const valueAsNumber = Number(value)

  return (Number(min) <= valueAsNumber && Number(max) >= valueAsNumber) || `Digite um número entre ${min} e ${max}`
}

export const integerValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  if (Array.isArray(value)) {
    return value.every(val => /^-?[0-9]+$/.test(String(val)))
  }

  return /^-?[0-9]+$/.test(String(value)) || 'Este campo deve ser um número inteiro'
}

export const regexValidator = (value, regex) => {
  if (isEmpty(value)) {
    return true
  }

  let regeX = regex
  if (typeof regeX === 'string') {
    regeX = new RegExp(regeX)
  }

  if (Array.isArray(value)) {
    return value.every(val => regexValidator(val, { regeX }))
  }

  return regeX.test(String(value)) || 'O formato do campo Regex é inválido'
}

export const nameValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  return /^[A-ZÀ-Ú\s]*$/gi.test(String(value)) || 'O campo só pode conter letras e não pode conter números'
}

export const alphaValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  return /^[A-Z]*$/i.test(String(value)) || 'O campo só pode conter caracteres alfabéticos'
}

export const urlValidator = value => {
  if (value === undefined || value === null || value.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/

  return re.test(value) || 'URL is invalid'
}

export const lengthValidator = (value, length) => {
  if (isEmpty(value)) {
    return true
  }

  return value.length === length || `O campo Min Character deve ter pelo menos ${length} caracteres`
}

export const alphaDashValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  const valueAsString = String(value)

  return /^[0-9A-Z_-]*$/i.test(valueAsString) || 'Todos os caracteres não são válidos'
}
